import React from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import { Field } from 'redux-form';
import { SelectField } from '../../../../../common/components/ReduxFormField';
import { required } from 'redux-form-validators';
import { FormSection } from 'redux-form';

const MONTHS = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
  { label: "Don't Know", value: "Don't Know" },
];
const yesOrNo = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: "Don't Know", value: "Don't Know" },
];

const PurchaseQuestion = ({ show, name, label, type }) => {
  if (!show) {
    return null;
  }

  return (
    <Col sm={12}>
      <Field
        name={name}
        placeholder="Please select"
        options={yesOrNo}
        component={SelectField}
        label={label}
        labelSize={7}
        errorClass="input-error-home-insurance"
        validate={required({ msg: `${type} insurance purchased required` })}
      />
    </Col>
  );
};

const WhenDueQuestion = ({ name, label, validationMsg }) => {
  return (
    <Col sm={12}>
      <Field
        name={name}
        placeholder="Please select"
        options={MONTHS}
        component={SelectField}
        label={label}
        labelSize={7}
        validate={required({ msg: validationMsg })}
        errorClass="input-error-home-insurance"
      />
    </Col>
  );
};
const AdditionalHomeInfo = ({ isCustomerEditPage, type, isEnabled }) => {
  if (isEnabled) {
    return (
      <>
        <PurchaseQuestion
          name={`metadata.marketing_additional_info.${type}_insurance_purchased`}
          label={`Did client purchase ${type} Insurance?`}
          type={type}
          show={isCustomerEditPage}
        />
        <WhenDueQuestion
          name={`metadata.marketing_additional_info.${type}_insurance_due`}
          label={
            <>
              When is your <span className={'capitalise'}>{type}</span> Insurance due?
            </>
          }
          validationMsg={`${type} insurance due required`}
        />
      </>
    );
  }

  return null;
};

const MarketingAdditionalInfo = ({
  isCustomerEditPage,
  isCarInsuranceMarketingEnabled,
  isHomeInsuranceMarketingEnabled,
}) => {
  return (
    <FormSection
      name={isCustomerEditPage ? 'data.attributes' : 'data.attributes.metadata.adults[0]'}
    >
      <FormGroup>
        <AdditionalHomeInfo
          type={'home'}
          isCustomerEditPage={isCustomerEditPage}
          isEnabled={isHomeInsuranceMarketingEnabled}
        />
        <AdditionalHomeInfo
          type={'car'}
          isCustomerEditPage={isCustomerEditPage}
          isEnabled={isCarInsuranceMarketingEnabled}
        />
      </FormGroup>
    </FormSection>
  );
};

export default MarketingAdditionalInfo;
